import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import {
    Link,
    useHistory
} from "react-router-dom";
import ArrowRight from '../../../assets/icons/arrow-right-red.svg';
import { Wrapper, Row, Col, Container } from '../../../components/layout';
import { PrimaryButton, OutlineButtonIcon } from '../../../components/buttons';
import { Td } from '../../../components/table';
import useGetUserData from '../../../lib/hooks/useGetUserData';
import useGetUserPosts from '../../../lib/hooks/useGetUserPosts';
import LoadingIndicator from '../../../components/loading';
import { SocialMediaList } from '../../../components/';
import { getTeamLogo, mobileBreakpoint } from '../../../lib';
import { useMediaQuery } from 'react-responsive';
import { DeleteItemModal } from '../../../components/modal';
import { deleteItem } from '../../../actions/api';
import NavigationMenu from '../../../components/navigationMenu';

const Draft = styled(Row)`
    background-color: #161718;
    height: 62px;
    margin-bottom: 10px;
    align-items: center;
    flex-wrap: nowrap;
    position: relative;
`;

const TeamLogo = styled.img.attrs(props => ({
    src: props.src
}))`
    width: 100%;
    height: 100%;
    max-width: 32px;
    height: 32px;
    margin-right: 6px;
`;

const ExtraTeams = styled.div`
    width: 38px;
    height: 38px;
    background-color: #000000;
    display: flex;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
`;

const MyWrapper = styled(Wrapper)`
    padding-top: 0;
`


function TeamLogoList({ teams }){
    return <>
            {teams.slice(0,5).map((code) => <TeamLogo src={getTeamLogo(code)} />)}
            {teams.length > 5 && <ExtraTeams><b>+{26}</b></ExtraTeams>}
        </>
}

function SavedDraft({ draft, setSelectedId }) {
    const isTablet = useMediaQuery({minWidth: 1090});
    const isMobile = useMediaQuery({maxWidth: mobileBreakpoint});
    const parsedData = JSON.parse(draft.data);
    let date = new Date(draft.date);
    date = date.toLocaleString('en-us', {month: 'short', day: 'numeric', year: 'numeric'});
    const parsedDate = date.split(' ');
    let title = draft.title.rendered.replace(/\b\w/g, l => l.toUpperCase());
    if(title.length >= 25) title = title.substr(0,25) + '...';

    return (
        <Draft>
            <Td width="5%">
                <svg style={{display: 'flex', margin: '0 auto', cursor: 'pointer'}} width="25px" height="25px" viewBox="0 0 35 35" version="1.1" onClick={setSelectedId}>
                    <g id="Icon/close/2px">
                        <path d="M19.0909 0L0 19.0909L19.0909 0Z" transform="translate(7.954545 7.954545)" id="Path-3-Copy-4" fill="none" stroke="#d6001c" strokeWidth="2" />
                        <path d="M19.0909 19.0909L0 0L19.0909 19.0909Z" transform="translate(7.954545 7.954545)" id="Path-3-Copy-5" fill="none" stroke="#d6001c" strokeWidth="2" />
                    </g>
                </svg>
            </Td>
            <Td width="8%">
                {`${parsedDate[0]} ${parsedDate[1].substr(0,2)}/${parsedDate[2].substr(2,2)}`}
            </Td>
            <Td width={isMobile ? '17%' : '12%'}>
                {'Draft year'.toUpperCase()} <b>{parsedData.year}</b>
            </Td>
            <Td width={isMobile ? '55%' : '20%'}>{title}</Td>
            {!isMobile && <Td width={isTablet ? '25%' : '45%'} style={{display: 'flex'}}>
                <TeamLogoList teams={parsedData.selectedTeams} />
            </Td>}
            {isTablet &&
            <Td width="18%">
                <SocialMediaList postId={draft.id} type="drafts"/>
            </Td>}
            <Td width={isMobile ? '15%' : '10%'}>
                <Link to={`/mock-draft/${draft.id}`}>
                    <OutlineButtonIcon background="#161718" marginLeftIcon="5px" icon={ArrowRight}>View Draft</OutlineButtonIcon>
                </Link>
            </Td>
        </Draft>
    );
}

function SavedDrafts(){
    // let { path, url } = useRouteMatch();
    let history = useHistory();
    const { userId } = useGetUserData();
    const [ isDeleteModalOpen, setIsDeleteModalOpen ] = useState(false);
    const [ selectedId, setSelectedId ] = useState('');
    const [ deletedIds, setDeletedIds ] = useState([]);
    const [ deleting, setDeleting ] = useState(false);
    const [ drafts, loading ] = useGetUserPosts(userId, 'drafts');

    document.title = "Saved Drafts - FCHockey";

    const handleDelete =  async() => {
        setDeleting(true);
        const res = await deleteItem(selectedId, 'drafts');
        setDeleting(false);
        setIsDeleteModalOpen(false);
        setDeletedIds([...deletedIds, res.previous.id]);
    }
    useEffect(() => {
        if(selectedId) setIsDeleteModalOpen(true);
    }, [ selectedId ]);
    useEffect(() => {
        if(selectedId && !isDeleteModalOpen) setSelectedId('');
    }, [ selectedId, isDeleteModalOpen ]);

    return (
        <MyWrapper>
            <DeleteItemModal
                item="draft"
                handleModalOpen={setIsDeleteModalOpen}
                isOpen={isDeleteModalOpen}
                handleDeleteItem={handleDelete}
                disabled={deleting}
            />
            <NavigationMenu noPadding/>
            <Row margin="0 0 40px 0" justifyContent="space-between" alignItems="center">
                <Col>
                    <h1>My saved drafts</h1>
                </Col>
                <Col>
                    <PrimaryButton padding="10px 45px" onClick={() => history.push('/mock-draft')}>Start mock draft</PrimaryButton>
                </Col>
            </Row>
            {loading ? <LoadingIndicator /> : <Container>
                {drafts
                    .filter((d) => !deletedIds.some((x) => x === d.id))
                    .sort((a, b) => new Date(b.date) - new Date(a.date))
                    .map((draft, id)=> <SavedDraft key={draft.id} draft={draft} setSelectedId={() => setSelectedId(draft.id) }/>)}
            </Container>}
        </MyWrapper>
    )
}

export default SavedDrafts;